import { Transaction } from 'prosemirror-state'
import { trackChangesKey } from './constants'
import { rejectAll as coreRejectAll, reject as coreReject } from 'prose-core'

export function reject(uuid: string, tr: Transaction) {
  tr.setMeta(trackChangesKey, {
    disposition: { uuid },
  })
  coreReject(uuid, tr)
}

export function rejectAll(tr: Transaction) {
  tr.setMeta(trackChangesKey, {
    disposition: true,
  })
  coreRejectAll(tr)
}
